import { Field, InputType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'
import type { IAction } from '../../action/IAction'
import type { Order } from '../Order'

export interface IRemoveToCart extends IAction<Order, RemoveToCartArgs> {}

@InputType()
export class RemoveToCartArgs extends ActionArgs {
  @Field(() => String)
  orderId: string

  @Field(() => String)
  itemId: string
}
